"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Undo = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.95710678,10.25 C9.13067313,10.4235664 9.14995828,10.6929908 9.01496223,10.8878589 L8.95710678,10.9571068 C8.78354043,11.1306731 8.51411603,11.1499583 8.31924789,11.0149622 L8.25,10.9571068 L4.89644661,7.60355339 L8.25,4.25 C8.44526215,4.05473785 8.76184464,4.05473785 8.95710678,4.25 C9.13067313,4.42356635 9.14995828,4.69299075 9.01496223,4.88785889 L8.95710678,4.95710678 L6.91344661,6.99955339 L14,7 C17.3137085,7 20,9.6862915 20,13 C20,16.2383969 17.4344251,18.8775718 14.2249383,18.9958615 L14,19 L11,19 L11,18 L14,18 C16.7614237,18 19,15.7614237 19,13 C19,10.3112453 16.8776933,8.11818189 14.2168896,8.00461951 L14,8 L6.70744661,7.99955339 L8.95710678,10.25 Z" })));
};
Undo.displayName = 'Undo';
exports.default = Undo;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Undo.js.map